import {makeReactContext} from 'lib/makeReactContext';

export interface CloseableDropdownContextType {
  onCloseDropdown: () => void;
}

/**
 * This context passes the onCloseDropdown helper from the Dropdown to the downstream SearchableMenu.
 * We don't directly pass it is as a prop to SearchableMenu because the menu component can be wrapped
 * in one or multiple layers.
 */
export const CloseableDropdownContext = makeReactContext<CloseableDropdownContextType>(
  () => ({
    onCloseDropdown: () => {},
  }),
  'CloseableDropdownContext'
);

export function useCloseableDropdownContext(): CloseableDropdownContextType {
  return CloseableDropdownContext.useContext();
}
